import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import {
  parsedCoupon,
  selectedCoupon,
} from 'app/features/couponCampaign/selectors';
import {
  isEligibleForFreeTrial,
  isUserAuthenticated,
  userSessionId,
} from 'app/features/user/selectors';
import { getRoutePathname } from 'app/router/selectors';
import { XBOX_LANDING_PATH } from 'app/router/constants/paths';

const couponReset = createAction('COUPON_RESET');
const couponSelected = createAction('COUPON_SELECTED');
const couponFlowSelected = createAction('COUPON_FLOW_SELECTED');
const couponLoadingStarted = createAction('COUPON_LOADING_STARTED');
const couponValidated = createAction('COUPON_VALIDATED');

const validateCoupon =
  () =>
  (dispatch, getState, { api }) => {
    const coupon = selectedCoupon(getState());

    return (
      coupon &&
      api
        .validateCoupon(coupon, userSessionId(getState()))
        .then(compose(dispatch, couponValidated))
    );
  };

const preselectCoupon = () => (dispatch, getState) => {
  dispatch(couponSelected(parsedCoupon(getState())));
  dispatch(couponLoadingStarted());
  dispatch(validateCoupon());
};

const preselectCouponForEligibleUser = () => (dispatch, getState) => {
  if (isEligibleForFreeTrial(getState())) {
    dispatch(preselectCoupon());
  }
};

const preselectCouponForAuthenticatedUser = () => (dispatch, getState) => {
  if (isUserAuthenticated(getState())) {
    dispatch(preselectCoupon());
  }
};

const startCouponFlow = () => (dispatch, getState) => {
  const routePathname = getRoutePathname(getState());

  compose(dispatch, couponFlowSelected)(routePathname);

  if (routePathname === XBOX_LANDING_PATH) {
    dispatch(preselectCouponForEligibleUser());
  } else {
    dispatch(preselectCouponForAuthenticatedUser());
  }
};

export {
  couponValidated,
  couponSelected,
  couponFlowSelected,
  couponLoadingStarted,
  couponReset,
  validateCoupon,
  preselectCouponForEligibleUser,
  preselectCouponForAuthenticatedUser,
  preselectCoupon,
  startCouponFlow,
};
